import { buildCsvString } from '../data-table/components/table-export/csv-utils';

/**
 * One exported claim row. There is deliberately no transmission message: payer rejection text can
 * carry patient details, and this file leaves the application.
 */
export interface CoderRuleClaimCsvRow {
    ruleNumber?: number;
    ruleDescription?: string;
    claimId: string;
    runDate?: string;
    transmissionStatus: string;
    transmissionDate?: string;
    claimUrl?: string | null;
}

export const CODER_RULE_CLAIMS_CSV_HEADERS = [
    'Rule number',
    'Rule description',
    'Claim ID',
    'Run date',
    'Transmission status',
    'Transmission date',
    'Claim link',
];

/** Local `YYYY-MM-DD HH:mm` — a form spreadsheets parse as a date. Empty when missing or unparseable. */
export function formatCsvDate(value?: string) {
    const time = value ? Date.parse(value) : NaN;

    if (Number.isNaN(time)) {
        return '';
    }

    const date = new Date(time);
    const pad = (part: number) => String(part).padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
        date.getMinutes(),
    )}`;
}

export function buildCoderRuleClaimsCsv(rows: CoderRuleClaimCsvRow[]) {
    return buildCsvString(
        rows.map(row => ({
            'Rule number': row.ruleNumber ?? '',
            'Rule description': row.ruleDescription || '',
            'Claim ID': row.claimId,
            'Run date': formatCsvDate(row.runDate),
            'Transmission status': row.transmissionStatus,
            'Transmission date': formatCsvDate(row.transmissionDate),
            'Claim link': row.claimUrl || '',
        })),
        CODER_RULE_CLAIMS_CSV_HEADERS,
    );
}

export function buildCoderRuleClaimsCsvFilename(ruleNumber: number | undefined, now = new Date()) {
    const ruleLabel = typeof ruleNumber === 'number' ? `rule-${ruleNumber}` : 'rule';

    return `coder-${ruleLabel}-claims-${formatCsvDate(now.toISOString()).slice(0, 10)}.csv`;
}
